import { getAdjustedDirection } from '../../../../utils/animationsUtils';
const name = 'FlipIn';
const properties = { schema: {} };
const paramsMap = {
    top: { x: 1, y: 0, idx: 0 },
    right: { x: 0, y: 1, idx: 1 },
    bottom: { x: -1, y: 0, idx: 2 },
    left: { x: 0, y: -1, idx: 3 },
};
const powerMap = {
    soft: { initialRotate: 45 },
    medium: { initialRotate: 90 },
    hard: { initialRotate: 270 },
};
function animate(kit, elements, duration, delay, { direction = 'top', easing = 'backOut', power, initialRotate = 90, ...params } = {}) {
    const sequence = kit.sequence(params);
    const rotation = typeof power !== 'undefined'
        ? powerMap[power].initialRotate
        : initialRotate;
    sequence.add(kit.animate('BaseFade', elements, 0, 0, { to: { opacity: 0.01 } }));
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        to: {
            opacity: 1,
        },
        ease: 'quadOut',
    }), 'animation-start');
    elements.forEach((element) => {
        const elementAngleInDeg = Number(kit.engine.getProperty(element, '--comp-rotate-z') || 0);
        const adjDirection = getAdjustedDirection(paramsMap, direction, elementAngleInDeg);
        const from = {
            rotationX: paramsMap[adjDirection].x * rotation,
            rotationY: paramsMap[adjDirection].y * rotation,
        };
        sequence.add(kit.animate('BaseRotate3D', element, duration, delay, {
            from,
            perspective: 800,
            ease: easing,
        }), 'animation-start');
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=flipIn.js.map